import { createContext, useContext } from 'react';

interface InputRatingContextProps {
	variant: string;
	invalid: boolean;
	readOnly: boolean;
	disabled: boolean;
}

export const InputRatingContext = createContext<InputRatingContextProps>(undefined as unknown as InputRatingContextProps);

export function useInputRatingContext(): InputRatingContextProps {
	const context = useContext(InputRatingContext);
	if (context === undefined) {
		throw new Error('useInputRatingContext must be used within a InputRadio.Root');
	}

	return context;
}
